import { FC, useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { multiply } from 'lodash';
import { Button, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Check from 'src/pages/Van/components/item/CheckIcon';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { useActions } from 'src/hooks/useActions';
import { IOrderForClient } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderForClient;
  insurance: string;
}

const InsuranceCard: FC<IProps> = ({ order, insurance }) => {
  const { updateOrder } = useActions();
  const extras = useTypedSelector(state => state.extra.extraList);
  const [value, setValue] = useState('RENTERS COLLISION PROTECTION: $76/Day');
  const { id, start_date, end_date, fee_list } = order;

  useEffect(() => {
    if (insurance.length) setValue(insurance);
  }, [insurance]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  const handleSubmit = () => {
    const extra = extras.find(el => el.name === value);

    if (extra) {
      const days = Math.ceil(
        DateTime.fromISO(end_date!).diff(DateTime.fromISO(start_date!), ['days']).toObject().days!
      );
      const startIdx = extra.name.indexOf('$') + 1;
      const endIdx = extra.name.lastIndexOf('/');
      const priceByDay = multiply(Number(extra.name.substring(startIdx, endIdx)), 100);
      extra.price = multiply(priceByDay, days);
      updateOrder({ id: id, fee_list: [...fee_list, extra] });
    }
  };

  return (
    <div className='insurance-card'>
      <div className='client__order__main__header'>
        <div>
          <p className='insurance-card__title'>I’d like to purchase coverage</p>
          <h6>
            View coverage terms&nbsp;
            <a
              href='https://www.sprinter-rentals.com/trip-coverage'
              target='_blank'
              style={{ textDecoration: 'underline' }}
            >
              here
            </a>
            .
          </h6>
        </div>
      </div>
      <FormControl sx={{ display: 'inline' }} disabled={!!insurance.length}>
        <RadioGroup value={value} onChange={handleChange}>
          <FormControlLabel
            value='RENTERS COLLISION PROTECTION: $76/Day'
            control={<Radio />}
            sx={{ alignItems: 'flex-start' }}
            label={
              <div className='insurance-card__label'>
                <span>RENTER’S COLLISION PROTECTION $76.00 / day</span>
                <p>
                  The Company will pay this benefit up to a maximum of $35,000 subject to a $250
                  deductible.
                </p>
              </div>
            }
          />
          <FormControlLabel
            value='AUTO LIABILITY COVERAGE: $63/Day'
            control={<Radio />}
            sx={{ alignItems: 'flex-start' }}
            label={
              <div className='insurance-card__label'>
                <span>AUTO LIABILITY COVERAGE $63.00 / day</span>
                <p>
                  This covers damage to third party vehicles/property and injuries. Does not cover
                  your van.
                  <br />
                  $15,000 per person
                  <br />
                  $30,000 per accident
                  <br />
                  $5,000 property damage
                  <br />
                </p>
              </div>
            }
          />
          <FormControlLabel
            value='PACKAGE: RENTERS COLLISION PROTECTION & AUTO LIABILITY COVERAGE: $139/Day'
            control={<Radio />}
            label={
              <div className='insurance-card__label'>
                <span>PURCHASE BOTH $139.00 / day</span>
              </div>
            }
          />
        </RadioGroup>
      </FormControl>
      <div className='insurance-card__info'>
        <span>No Refunds. See Limits and conditions. </span>
        <p>
          Cancellation: You may cancel your booking, however no refunds on coverage.
          <br />
          Provided by Schalberg
        </p>
      </div>
      <div className='insurance-card__agreement'>
        <Check />
        <span>
          I understand and agree to the&nbsp;
          <a href='https://www.sprinter-rentals.com/trip-coverage' target='_blank'>
            coverage terms
          </a>
        </span>
      </div>
      <div className='insurance-card__container'>
        <Button onClick={handleSubmit} disabled={!!insurance.length}>
          Buy Trip Coverage{' '}
        </Button>
      </div>
    </div>
  );
};

export default InsuranceCard;
